import { logger } from '@vista/omnichannel-components-domain';
import { MemberPaymentCardWalletViewActionType as ActionType } from './view-action-type';
export const memberPaymentCardWalletViewActionReducer = (state, action) => {
    var _a, _b, _c;
    switch (action.type) {
        case ActionType.CloseModal:
            return Object.assign(Object.assign({}, state), { showMakePrimaryModal: false, showRemoveModal: false });
        case ActionType.MakePrimaryButtonClicked:
            return Object.assign(Object.assign({}, state), { showMakePrimaryModal: true, canReactivate: action.canReactivate, card: action.card });
        case ActionType.RemoveButtonClicked: {
            const { card, canRemove } = action;
            return Object.assign(Object.assign({}, state), { showRemoveModal: true, canRemove: canRemove, card: card });
        }
        case ActionType.RemoveCallStarted:
            return Object.assign(Object.assign({}, state), { cardIdBeingRemoved: (_a = state.card) === null || _a === void 0 ? void 0 : _a.id });
        case ActionType.MakePrimaryCallStarted:
            return Object.assign(Object.assign({}, state), { cardIdBeingMadePrimary: ((_b = action.card) === null || _b === void 0 ? void 0 : _b.id) || ((_c = state.card) === null || _c === void 0 ? void 0 : _c.id) });
        case ActionType.CallFinished:
            return Object.assign(Object.assign({}, state), { cardIdBeingRemoved: undefined, cardIdBeingMadePrimary: undefined });
        case ActionType.UpdateIsAddingCard:
            return Object.assign(Object.assign({}, state), { isAddingCard: action.isAddingCard });
        default: {
            logger.error(`Unknown MemberPaymentCardWalletViewAction ${action.type}.`);
            return state;
        }
    }
};
